import VcomProvider from '../../VcomProvider';

const Locale = {
  getLanguageCode() {
    const language = VcomProvider.LanguageSwitch.getCurrentLanguage();
    if (language === 'us') {
      return 'en';
    }
    return language;
  },
};

export default Locale;
